import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {gtmEventPropertyListClick} from "../../../../tracking/google_tag_manager/gtm_event_property_list";
import {hitGTMPropertySelectItem} from "../../../tracking/ecommerce_events/property/hit_gtm_property_select_item";
import {offerBoxTracking} from "../../../tracking/offer_box_gtm_events";
import {IOfferBoxGTMSource} from "../../../types/IOfferBoxGTMSource";
import {IOfferModalOffer} from "../../../types/OfferModalOffer";
import {OfferModalPropertyCard} from "./OfferModalPropertyCard";

interface IProps {
    property: IPropertyListProperty;
    offer: IOfferModalOffer;
    index: number;
    gtmMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
}

export function OfferModalPropertiesListItem(props: IProps) {
    const {property, offer, index, gtmMeta} = props;

    const onClick = () => {
        gtmEventPropertyListClick("rzut");
        hitGTMPropertySelectItem({
            offer,
            property,
            listName: gtmMeta.listName,
            listId: gtmMeta.listId
        });

        if (gtmMeta.source === "listing") {
            offerBoxTracking.gtm.investTileOfferModal(index);
        } else {
            offerBoxTracking.gtm.investAdditionalOfferModal(index);
        }
    };

    return <OfferModalPropertyCard property={property} offer={offer} onClick={onClick} />;
}
import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {gtmEventPropertyListClick} from "../../../../tracking/google_tag_manager/gtm_event_property_list";
import {hitGTMPropertySelectItem} from "../../../tracking/ecommerce_events/property/hit_gtm_property_select_item";
import {offerBoxTracking} from "../../../tracking/offer_box_gtm_events";
import {IOfferBoxGTMSource} from "../../../types/IOfferBoxGTMSource";
import {IOfferModalOffer} from "../../../types/OfferModalOffer";
import {OfferModalPropertyCard} from "./OfferModalPropertyCard";

interface IProps {
    property: IPropertyListProperty;
    offer: IOfferModalOffer;
    index: number;
    gtmMeta: {
        listName: string;
        listId: string;
        source: IOfferBoxGTMSource;
    };
}

export function OfferModalPropertiesListItem(props: IProps) {
    const {property, offer, index, gtmMeta} = props;

    const onClick = () => {
        gtmEventPropertyListClick("rzut");
        hitGTMPropertySelectItem({
            offer,
            property,
            listName: gtmMeta.listName,
            listId: gtmMeta.listId
        });

        if (gtmMeta.source === "listing") {
            offerBoxTracking.gtm.investTileOfferModal(index);
        } else {
            offerBoxTracking.gtm.investAdditionalOfferModal(index);
        }
    };

    return <OfferModalPropertyCard property={property} offer={offer} onClick={onClick} />;
}
